import { API } from "../Auth";
import { kindForSource } from './LandscapeUtils';
import { isPlatformResource, platformResourceReason } from './platformResources';

const MANAGER = 'manager';

const READ_ONLY_SOURCES = new Set([
  's3',
  'azure_storage',
  'azure_blob', // legacy alias
  'gcs',
]);

const isReadOnlySource = (rowData) => {
  const source = (rowData && rowData.source) || '';
  return (
    rowData &&
    (rowData.connectionType === 's3' ||
      rowData.engineMode === 'serverless' ||
      READ_ONLY_SOURCES.has(source) ||
      kindForSource(source) === 'files')
  );
};

const isTransitioning = (status) => status === 'starting' || status === 'stopping' || status === 'pending';

const startStopService = async (rowData) => {
  if (!rowData) return undefined;
  if (isReadOnlySource(rowData) || isTransitioning(rowData.status)) {
    console.log('startStopService: skipping (read-only or transitioning)', rowData.identifier);
    return rowData.status;
  }
  // Rows hosting the platform itself (Terraform `c2pp:cluster` tag, EKS/AKS node tags, or a
  // product-named host) never get a lifecycle call — the UI disables the toggle, this is the
  // belt to that suspenders.
  if (isPlatformResource(rowData)) {
    console.log('startStopService: skipping (platform resource)', rowData.identifier);
    return rowData.status;
  }

  const toStart = rowData.status === 'stopped';
  const path = '/manage/datasource/' + (toStart ? 'start' : 'stop');
  const body = {
    cloud: rowData.cloud || 'aws',
    source: rowData.source,
    identifier: rowData.identifier,
    region: rowData.region,
    host: rowData.host,
    port: rowData.port,
    engine: rowData.engine,
    engineMode: rowData.engineMode,
  };

  try {
    const response = await API.post(MANAGER, path, body, true);
    if (response && response.status === 400) {
      console.log('startStopService: not supported by provider', body);
      return 'not_supported';
    }
    const payload = (response && response.data) || {};
    let newValue = payload.message;
    if (newValue == null) newValue = toStart ? 'starting' : 'stopping';
    if (newValue === 'pending') newValue = 'starting';
    rowData.status = newValue;
    return newValue;
  } catch (e) {
    console.log('startStopService error', e);
    throw e;
  }
};

const providerQueryString = (providerFilter) =>
  providerFilter && providerFilter !== 'all'
    ? `?provider=${encodeURIComponent(providerFilter)}`
    : '';

const startManagedLandscapeDiscovery = async (providerFilter) => {
  try {
    const path = '/landscape/search' + providerQueryString(providerFilter);
    const response = await API.post(MANAGER, path);
    console.log('startManagedLandscapeDiscovery response', response);
    return response;
  } catch (e) {
    console.log('startManagedLandscapeDiscovery error', e);
    throw e;
  }
};

const getLandscape = async () => {
  try {
    const response = await API.get(MANAGER, '/landscape');
    return response || { time_stamp: 0, sources: [], errors: [] };
  } catch (e) {
    console.log('getLandscape error', e);
    return { time_stamp: 0, sources: [], errors: [] };
  }
};

const getProviders = async () => {
  try {
    const response = await API.get(MANAGER, '/landscape/providers');
    return response || {};
  } catch (e) {
    console.log('getProviders error', e);
    return {};
  }
};

export {
  startManagedLandscapeDiscovery,
  getLandscape,
  getProviders,
  startStopService,
  isReadOnlySource,
  isPlatformResource,
  platformResourceReason,
};
